module.exports = __webpack_public_path__ + "img/s2-1.c33fb97c.svg";